import {
  CheckOutlined,
  ClockCircleOutlined,
  CloseOutlined,
  RollbackOutlined
} from '@ant-design/icons';
import {Tooltip} from 'antd';
import {TagProps} from 'antd/es/tag';
import {ChargeFieldsFragment, ChargeStatus} from 'api/generated';
import {StatusTag} from 'components/StatusTag';
import {colors} from 'lib/colors';
import React from 'react';
import {getChargeMessage} from './TimelineChargeMessage';
import styled from 'styled-components';
import {responsiveSizesMap} from '../lib/responsive';

interface Props extends TagProps {
  charge: ChargeFieldsFragment;
}

const StyledTooltip = styled(Tooltip)`
  @media (max-width: ${responsiveSizesMap.md}px) {
    .label {
      display: none;
    }
  }
`;

export const ChargeStatusTag: React.FC<Props> = ({charge, ...props}) => {
  const getStatusTag = () => {
    switch (charge.status) {
      case ChargeStatus.AUTHORIZED:
        return (
          <StatusTag {...props} color={colors.grey}>
            <span className="label">Uncaptured</span> <ClockCircleOutlined />
          </StatusTag>
        );
      case ChargeStatus.FAILED:
        return (
          <StatusTag {...props} color={colors.grey}>
            <span className="label">Failed</span> <CloseOutlined />
          </StatusTag>
        );
      case ChargeStatus.CANCELED:
        return (
          <StatusTag {...props} color={colors.grey}>
            <span className="label">Canceled</span> <CloseOutlined />
          </StatusTag>
        );
      case ChargeStatus.EXPIRED:
        return (
          <StatusTag {...props} color={colors.grey}>
            <span className="label">Expired</span> <CloseOutlined />
          </StatusTag>
        );
      case ChargeStatus.PENDING:
        return (
          <StatusTag {...props} color={colors.grey}>
            <span className="label">Started</span> <ClockCircleOutlined />
          </StatusTag>
        );
      case ChargeStatus.PENDING_PROCESSING:
        return (
          <StatusTag {...props} color={colors.grey}>
            <span className="label">Pending processing</span> <ClockCircleOutlined />
          </StatusTag>
        );
      case ChargeStatus.REFUNDED:
        return (
          <StatusTag {...props} color={colors.grey}>
            <span className="label">Refunded</span> <RollbackOutlined />
          </StatusTag>
        );
      case ChargeStatus.PARTIALLY_REFUNDED:
        return (
          <StatusTag {...props} color={colors.grey}>
            <span className="label">Partially refunded</span> <RollbackOutlined />
          </StatusTag>
        );
      case ChargeStatus.SUCCEEDED:
        return (
          <StatusTag {...props} color={colors.success}>
            <span className="label">Succeeded</span> <CheckOutlined />
          </StatusTag>
        );
      case ChargeStatus.PAID_OUT:
        return (
          <StatusTag {...props} color={colors.success}>
            <span className="label">Paid out</span> <RollbackOutlined />
          </StatusTag>
        );
    }

    return null;
  };

  return <StyledTooltip title={getChargeMessage({charge})}>{getStatusTag() as any}</StyledTooltip>;
};
